import type { Command } from "../CommandPaletteRegistry";

export type CommandOpenOptions = {
  id: string;
  /** Page name / label shown in the palette. */
  label: string;
  /** Path or URL to open (passed to navigate). */
  path: string;
  navigate: (path: string) => void;
  description?: string;
  signature: string;
  keywords?: string[];
};

/**
 * Build a command that opens a page (type: "open").
 */
export function commandOpen(options: CommandOpenOptions): Command {
  const { id, label, path, navigate, description, signature, keywords } = options;
  return {
    id,
    label,
    description,
    signature,
    type: "open",
    keywords,
    run: () => navigate(path),
  };
}

export type CommandCopyOptions = {
  id: string;
  /** Kind of id/value being copied (e.g. "tenant ID", "facility URL"). */
  idKind: string;
  /** Value to copy to clipboard. */
  value: string;
  copy: (text: string) => Promise<void> | void;
  description?: string;
  signature: string;
  keywords?: string[];
};

/**
 * Build a command that copies a value (type: "copy").
 */
export function commandCopy(options: CommandCopyOptions): Command {
  const { id, idKind, value, copy, description, signature, keywords } = options;
  const label = `Copy ${idKind}`;
  return {
    id,
    label,
    description: description ?? value,
    signature,
    type: "copy",
    keywords,
    run: () => copy(value),
  };
}
